import '../../app.scss';
import React, { useEffect } from "react";
import Banner from './main-banner/Banner.js';
import Navbar from './header/Navbar.js';
import About from './About/About.js';
import LatestTask from './LatestTask/LatestTask.js';
import How from './How/How.js';
import What from './Whatwedo/What.js';
import Join from './Join/Join.js';
import HowItWorks from './HowItWorks/HowItWorks.js';
import { useLocation } from 'react-router-dom';


function Landing() {
  // useEffect(() => {
  //   window.scrollTo(0, 0)
  // }, [])

  // console.log(`Current Network: "${process.env.REACT_APP_NETWORK}"`);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.replace('#', '');

      const timeout = setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [location]);

  return (
    <>
      {/* <Navbar /> */}
      <Banner />
      <div id='whyusetasks'>
        <About />
      </div>
      <LatestTask />
      <div id="howitworks">
        <HowItWorks />
      </div>
      {/* <How /> */}
      <What />
      <Join />
    </>
  );
}

export default Landing;